// https://p-app-receita-federal.estaleiro.serpro.gov.br/servicos-rfb-apprfb-perdcomp/apprfb-perdcomp/
//consulta/ni/45039237000114?dataInicial=2013-06-17&dataFinal=2024-06-13

import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { HttpClient, ServiceProvider } from "config/httpClient";
import { result } from "lodash";
import { hasUncaughtExceptionCaptureCallback } from "process";
import { SearchResult, SearchResultItem } from "types/service/searchResult";

const mapResults = (result: SearchResult) => {
  var searchResults = result.searchResults;
  return searchResults.map(
    (r) =>
      ({
        ...r,
        searchParams: result.searchParams,
      }) as SearchResultItem,
  );
};

export const useSearch = (enabled: boolean = true) =>
  useQuery({
    queryKey: ["searchList"],
    queryFn: () =>
      HttpClient(ServiceProvider.NinApi)
        .get<SearchResult[]>("/search1")
        .then<SearchResult[]>((r) => r.data),
  });

export const useSearchExport = (): { exportFile: (id: number) => any } => ({
  exportFile: async (id: number) =>
    await HttpClient(ServiceProvider.NinApi)
      .get(`/search/${id}/export`)
      .then((r) => r.data),
});
